export default {"src":"/_next/static/media/asparagus.51938884.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};